<template>
  <section class="bloc-two-images">
    <img class="img scroll-step js-scroll-show" :src="require(`@/${content.img_one}`)">
    <img class="img scroll-step js-scroll-show show-delay-100" :src="require(`@/${content.img_two}`)">
  </section>
</template>

<script>
export default {
  name: 'TwoImages',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-two-images {
    width: 100vw;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    background: $th-yellow;
    padding: rem(10px) 0;

    @include media($from: small) {
      padding: rem(16px) 0;
    }

   .img {
      width: calc(50% - 5px);
      height: grid(9, 8);
      object-fit: cover;

      @include media($from: small) {
        width: calc(50% - 8px);
      }
    }
  }
</style>
